import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupMaterias } from '../MateriaCarrera/LookupMaterias';
import {
  SELECT_LABELS,
  getSelectOptionValue,
  resolveCorrelatividadCondicionOption,
  selectPlaceholder,
  withSelectPlaceholder,
} from '../../services/selectOptions';

const CONDICION_OPTIONS = withSelectPlaceholder(
  [
    { value: 'A', label: 'Aprobada' },
    { value: 'R', label: 'Regular' },
  ],
  SELECT_LABELS.condicionCorrelativa
);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatCondicionLabel(value) {
  if (value === 'A') return 'Aprobada';
  if (value === 'R') return 'Regular';
  return value || '—';
}

export class UpdateCorrelativaRendir extends Component {
  static displayName = UpdateCorrelativaRendir.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      errorMessage: '',
      redirect: false,
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      showLookup: false,
      tipoLookup: null,
      materiaInicial: { codigo: '', nombre: '', codigoMostrar: '' },
      materiaCorrelativa: { codigo: '', nombre: '', codigoMostrar: '' },
      valueCondicion: selectPlaceholder(SELECT_LABELS.condicionCorrelativa),
      condicionValor: '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  async componentDidMount() {
    if (constantClass.canAccess('WWCorrelatividadesRendir')) {
      await this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleShowLookup = (tipo) => {
    if (!this.state.loading && !this.isReadOnly) {
      this.setState({ showLookup: true, tipoLookup: tipo });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookup: false, tipoLookup: null });
  };

  handleSelectMateriaItem = (e) => {
    const properties = e.split('%');
    this.clearFeedback();
    this.setState({
      materiaInicial: {
        codigo: properties[0],
        nombre: properties[2],
        codigoMostrar: properties[1],
      },
      showLookup: false,
      tipoLookup: null,
    });
  };

  handleSelectCorrelativaItem = (e) => {
    const properties = e.split('%');
    this.clearFeedback();
    this.setState({
      materiaCorrelativa: {
        codigo: properties[0],
        nombre: properties[2],
        codigoMostrar: properties[1],
      },
      showLookup: false,
      tipoLookup: null,
    });
  };

  handleCondicionChange = (option) => {
    this.clearFeedback();
    const value = option && option.value ? option.value : '';
    this.setState({ valueCondicion: option, condicionValor: value });
  };

  isFormValid() {
    return (
      this.state.materiaInicial.codigo.length > 0
      && this.state.materiaCorrelativa.codigo.length > 0
      && getSelectOptionValue(this.state.valueCondicion, this.state.condicionValor) !== ''
    );
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      this.setState({ redirect: true });
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }
    this.saveRecord();
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/crendir/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar los datos de la correlatividad.'
        ),
      });
      return;
    }

    const model = data.returnModel;
    const selectedCondicion = resolveCorrelatividadCondicionOption(
      CONDICION_OPTIONS,
      model.correlatividadRendirCondicion
    );

    this.setState({
      loadingInitial: false,
      materiaInicial: {
        codigo: model.materiaCarreraCod,
        nombre: model.materiaCarreraNombre,
        codigoMostrar: model.materiaCarreraMostrar,
      },
      materiaCorrelativa: {
        codigo: model.materiaCarreraCod2,
        nombre: model.materiaCarreraNecesaria,
        codigoMostrar: model.materiaCarreraMostrar2,
      },
      valueCondicion: selectedCondicion,
      condicionValor: selectedCondicion.value || '',
    });
  }

  async saveRecord() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/crendir', {
      method: 'POST',
      body: JSON.stringify({
        CorrelatividadRendirCod: this.state.id,
        MateriaCarreraCod2: this.state.materiaInicial.codigo,
        MateriaCarreraCod: this.state.materiaCorrelativa.codigo,
        CorrelatividadRendirCondicion: getSelectOptionValue(
          this.state.valueCondicion,
          this.state.condicionValor
        ),
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar la correlatividad. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  renderMateriaField() {
    const { materiaInicial, showLookup, tipoLookup, loading } = this.state;
    const isBusy = loading;
    const readOnly = this.isReadOnly;
    const displayValue = materiaInicial.codigoMostrar
      ? `${materiaInicial.codigoMostrar} - ${materiaInicial.nombre}`
      : '';

    return (
      <div className="md-form-page__field">
        <span className="md-form-page__label">Materia</span>
        {!readOnly ? (
          <button
            type="button"
            className="md-form-page__pick-btn"
            onClick={() => this.handleShowLookup('MATERIA')}
            disabled={isBusy}
          >
            Seleccione la Materia
          </button>
        ) : null}
        {showLookup && tipoLookup === 'MATERIA' ? (
          <LookupMaterias
            selectItem={this.handleSelectMateriaItem}
            hideLookup={this.handleHideLookup}
          />
        ) : null}
        <input
          className="md-form-page__input"
          type="text"
          value={displayValue}
          readOnly
          disabled
          aria-label="Materia"
        />
      </div>
    );
  }

  renderCorrelativaField() {
    const { materiaCorrelativa, showLookup, tipoLookup, loading } = this.state;
    const isBusy = loading;
    const readOnly = this.isReadOnly;
    const displayValue = materiaCorrelativa.codigoMostrar
      ? `${materiaCorrelativa.codigoMostrar} - ${materiaCorrelativa.nombre}`
      : '';

    return (
      <div className="md-form-page__field">
        <span className="md-form-page__label">Correlativa</span>
        {!readOnly ? (
          <button
            type="button"
            className="md-form-page__pick-btn"
            onClick={() => this.handleShowLookup('CORRELATIVA')}
            disabled={isBusy}
          >
            Seleccione la Correlativa
          </button>
        ) : null}
        {showLookup && tipoLookup === 'CORRELATIVA' ? (
          <LookupMaterias
            selectItem={this.handleSelectCorrelativaItem}
            hideLookup={this.handleHideLookup}
          />
        ) : null}
        <input
          className="md-form-page__input"
          type="text"
          value={displayValue}
          readOnly
          disabled
          aria-label="Correlativa"
        />
      </div>
    );
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-crendir" />;
    }

    const { loadingInitial, loading, loadError, valueCondicion, condicionValor, errorMessage } = this.state;
    const isBusy = loading;
    const readOnly = this.isReadOnly;
    const title = readOnly ? 'Detalle de Correlatividad para Rendir' : 'Modificar Correlatividad para Rendir';

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-crendir">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-crendir">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-crendir">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {readOnly
            ? 'Consulte la materia, correlativa y condición registradas.'
            : 'Actualice la materia, correlativa o condición y confirme los cambios.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {!readOnly && loading ? (
                <span className="md-form-page__loading">Guardando cambios, espere un momento...</span>
              ) : null}
            </div>

            {this.renderMateriaField()}
            {this.renderCorrelativaField()}

            <div className="md-form-page__field">
              <span className="md-form-page__label">Condición</span>
              {readOnly ? (
                <input
                  className="md-form-page__input"
                  type="text"
                  value={formatCondicionLabel(condicionValor)}
                  disabled
                  readOnly
                />
              ) : (
                <div className="md-form-page__select-wrap">
                  <Select
                    inputId="crendir-condicion-update"
                    classNamePrefix="md-form-page__select"
                    classNames={SELECT_CLASS_NAMES}
                    value={valueCondicion}
                    options={CONDICION_OPTIONS}
                    onChange={this.handleCondicionChange}
                    isDisabled={isBusy}
                  />
                </div>
              )}
            </div>

            {!readOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Confirmar
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
